// Utilitário para trabalhar com JWT no frontend

export const decodeJWT = (token) => {
  try {
    if (!token) return null;
    
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    
    const base64Url = parts[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    
    return JSON.parse(jsonPayload);
  } catch (error) {
    return null;
  }
};

export const isTokenExpired = (token) => {
  try {
    const decoded = decodeJWT(token);
    if (!decoded || !decoded.exp) return true;
    
    const currentTime = Math.floor(Date.now() / 1000);
    return decoded.exp < currentTime;
  } catch (error) {
    return true;
  }
};

export const isNewUser = (token) => {
  try {
    const decoded = decodeJWT(token);
    if (!decoded) return false;
    
    // Verificar múltiplas condições para usuário temporário
    if (decoded.newUser === true) return true;
    if (decoded.cpf && decoded.cpf.startsWith('999')) return true;
    
    return false;
  } catch (error) {
    return false;
  }
};

export const getUserFromToken = (token) => {
  try {
    const decoded = decodeJWT(token);
    if (!decoded) return null;
    
    return {
      id: decoded.id,
      cpf: decoded.cpf,
      token: decoded.token,
      brand: decoded.brand,
      newUser: decoded.newUser || (decoded.cpf && decoded.cpf.startsWith('999')),
      id_conversa: decoded.id_conversa
    };
  } catch (error) {
    return null;
  }
};

export const getConversationIdFromToken = (token) => {
  try {
    const decoded = decodeJWT(token);
    return decoded?.id_conversa || null;
  } catch (error) {
    return null;
  }
};